import { Component, input, InputSignal } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

import { ReferralInputWithRevertComponent } from '../Input-With-Revert/referralInputWithRevert.component';

@Component({
    selector: 'referral-routing',
    templateUrl: 'referralRouting.component.html',
    styleUrls: ['../referralPage.component.scss'],
    imports: [ReactiveFormsModule, ReferralInputWithRevertComponent],
})
export class ReferralRoutingComponent {
    form: InputSignal<FormGroup> = input<FormGroup>();
    systemReferral: InputSignal<Core.LitigationReferralModel> = input<Core.LitigationReferralModel>();
    originalReferral: InputSignal<Core.LitigationReferralModel> = input<Core.LitigationReferralModel>();
    coCounselFirmOptions: InputSignal<Weissman.Model.NameValuePair[]> = input<Weissman.Model.NameValuePair[]>([]);
}
